class Layout {
    constructor() {

    }

    initFixWorkDescriptions() {

        this.fixWorkDescriptions();
        this.fixWidows();

        $(window).on('resize', () => {
            this.fixWorkDescriptions();
        });

        // bind on load event to images
        $('.jsWorkImage').bind('load', (e) => {
            this.fixImageDescription($(e.currentTarget));
        });
    }

    fixWorkDescriptions() {

        if(ResponsiveBootstrapToolkit.is('>=md')) {

            // fix image descriptions
            $('.jsWorkImage').each((index, el) => {
                this.fixImageDescription($(el));
            });

            // fix text descriptions
            $('.jsWorkText').each((index, el) => {
                let text = $(el);
                let description = text.children('.jsWorkDescription');
                description
                    .width(text.width())
                    .removeClass('d-md-none');
            });
        }

    }

    fixImageDescription(img) {
        let ratio_resized = parseFloat(img.width()) / parseFloat(img.height());
        let ratio_original = parseFloat(img.data('ratio'));
        // if contained image has smaller width than its container, set the description width accordingly
        let descriptionWith = ratio_resized > ratio_original ? ratio_original * parseFloat(img.height()) : '';
        img.parent().next('.work__description').width(descriptionWith);
    }

    fixWidows() {
        $('.jsWidont').each((i, e) => {
            $(e).children('p').each((i,e) => {
                let paragraph = $(e).html();
                if(paragraph.indexOf('<br>') > -1) {
                    let lines = paragraph.split('<br>');
                    let linesFixed = [];
                    lines.forEach((e) => {
                        linesFixed.push(widont(e,'html'))
                    });
                    $(e).html(linesFixed.join('<br>'));
                } else {
                    $(e).html(widont($(e).html(),'html'));
                }
            });

        });
    }

    scrollTo(position, speed = 400, callback = function() {}) {

        if(typeof position == 'object') {
            position = position.offset().top;
        }

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (400) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: position
        }, speed, 'swing', callback);
    }
}

export default Layout;